module.exports = __webpack_public_path__ + "static/media/add_fact_third.6cc92f04.png";